module.exports = __webpack_public_path__ + "img/shop-rest-amount-icon.33a336dc.png";